import { UserResponseDto } from '@tradgine/data-access/auth';
import { OrganizationUser } from '../domain/organization-user.model';
import { toUserStatus } from './user-status.mapper';

export function toOrganizationUser(dto: UserResponseDto): OrganizationUser {
    return {
        id: dto.id,
        fullName: dto.fullName,
        position: dto.position,
        userName: dto.userName,
        roles: dto.roles,
        phoneNumber: dto.phoneNumber,
        email: dto.email,
        status: toUserStatus(dto.status),
    };
}
